export default {
  skipToContent: "Skip to content",
  loading: "Loading…",
  error: "Something went wrong",
  retry: "Try again",
  notFound: "Page not found",
  notFoundHint: "Check the address or return to the homepage.",
  home: "Home",
  save: "Save",
  saved: "Saved",
  add: "Add",
  cancel: "Cancel",
  delete: "Delete",
  create: "Create",
  edit: "Edit",
  close: "Close",
  back: "Back",
  yes: "Yes",
  no: "No",
  more: "Learn more",
  all: "All",
  copy: "Copy",
  copied: "Copied",
  download: "Download",
  open: "Open",
  confirm: "Confirm",
  required: "Required field",
  optional: "optional",
  empty: "Nothing found",
  apply: "Apply",
  reset: "Reset",
  submit: "Submit",
  language: "Language",
  languageRu: "Русский",
  languageEn: "English",
  brandName: "NBR",
  brandFull: "National Bibliographic Resource",
  brandTagline: "IFLA LRM catalogue: people, works, manifestations, prizes.",
  auth: {
    error: "Sign-in failed: {{message}}",
    redirecting: "Redirecting to sign-in…",
    finishing: "Finishing sign-in…",
    forbidden: "You do not have access to this page.",
  },
  pager: {
    navigation: "Pagination",
    previous: "Previous page",
    next: "Next page",
    page: "Page {{page}} of {{pages}}",
    total: "{{count}} records",
  },
  footer: {
    portalTitle: "Portal",
    infoTitle: "About",
    tagline: "National Bibliographic Resource — an authority catalogue based on IFLA LRM.",
    copyright: "© {{year}} Russian State Library. National Bibliographic Resource.",
    terms: "User agreement",
    personalDataConsent: "Personal data consent",
    personalDataProcessingPolicy: "Personal data processing policy",
    socialTitle: "Follow us",
    socialVk: "VK",
    socialTelegram: "Telegram",
  },
  opensInNewTab: "opens in a new tab",
  contactWidget: {
    aria: "Contact us",
    title: "Contact us",
    subtitle: "Message us on Telegram or VK and we will reply soon.",
  },
  landing: {
    heroTitle: "National Bibliographic Resource",
    heroAccent: "Knowledge modelled with IFLA LRM",
    heroLead:
      "An authority catalogue of people, works, manifestations and prizes. Search with facets, explore relations and export citations.",
    openCatalog: "Open the catalogue",
    sparqlCta: "Select by criteria",
    statsTitle: "Catalogue at a glance",
    newsTitle: "News",
    allNews: "All news",
  },
  news: {
    title: "News",
    empty: "No published news yet.",
  },
  about: {
    title: "About",
    fallback:
      "The National Bibliographic Resource is a Russian State Library portal. The catalogue follows IFLA LRM: works, expressions, manifestations, persons, collective agents, concepts and prizes are linked by typed relations and available via search, entity cards and SPARQL.",
  },
  contactsPage: {
    kicker: "Get in touch",
    title: "Contacts",
    writeUs: "Write to us",
    sentTitle: "Message sent!",
    sentHint: "We will reply within 1–2 business days.",
    name: "Name",
    email: "Email",
    subject: "Subject",
    message: "Message",
    send: "Send message",
    address: "Address",
    phone: "Phone",
    emailBlock: "Email",
    officialPages: "Official pages",
    siteLabel: "Russian State Library website",
    socialNetworks: "Social networks",
    subjects: {
      general: "General question",
      events: "Events",
      deposit: "Deposits",
      tech: "Technical issues",
      coop: "Partnership",
    },
  },
  legalPages: {
    agreementTitle: "User agreement",
    personalTitle: "Personal data consent",
    privacyTitle: "Personal data processing policy",
  },
}
